import './polyfills';
import { LicenseManager, ModuleRegistry, AllEnterpriseModule } from 'ag-grid-enterprise';

// Register AG Grid Enterprise modules globally
ModuleRegistry.registerModules([AllEnterpriseModule]);

// Set license key globally (only once)
LicenseManager.setLicenseKey(environment.agGridLicense);

// TODO: Uncomment for use panoramo SDK locally
// const RealWorker = window.Worker;
// (window as any).Worker = function (url: string | URL, options?: WorkerOptions) {
//   const originalUrl = typeof url === 'string' ? url : url.toString();
//
//   // Detect unwanted file path
//   if (originalUrl.includes('@fs')) {
//     const filename = originalUrl.split('/').pop();
//     const patchedUrl = `http://localhost:4200/${filename}`;
//     return new RealWorker(patchedUrl, options);
//   }
//
//   return new RealWorker(url, options);
// };

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';

import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

// Global error handler for Application Insights
window.addEventListener('error', (error) => {
  console.error('Global error:', error.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((err) => {
    console.error(err);
    // Application Insights will be initialized in the service and will track this error
  });
